import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import { withRouter } from "react-router";

import * as kiosk from "../api/kiosk";

// Figma "Kiosk Status" (node 3051:21). Colours are the frame's variable tokens.
const GREEN = "#34c759"; // Accents/Green
const RED = "#ff383c"; // Accents/Red
const BORDER = "#c7c7cc"; // Grays/Gray 3
const PRIMARY = "#002bb8"; // app primary blue

/**
 * The Kiosk Online / Kiosk Disconnected badge, fixed in the bottom-left corner
 * of the sign-in page.
 *
 * Online means a station token is present in localStorage and has not plainly
 * expired — that credential is what unlocks reassessment prefill. Disconnected
 * shows a Login button that sends staff to the kiosk-mode login. The status is
 * read once on mount: the token only ever changes on the /login route, so the
 * page (and this badge) remounts on the way back.
 */
class KioskStatus extends Component {
  constructor(props) {
    super(props);
    this.state = { online: KioskStatus.isOnline() };
  }

  static isOnline() {
    const token = kiosk.readStationToken();
    if (!token) return false;
    const expiry = kiosk.stationTokenExpiry(token);
    // A token whose exp cannot be read is treated as usable — the server is the
    // real authority and rejects it if it is actually invalid.
    return expiry === null ? true : expiry > Date.now();
  }

  handleLogin = () => {
    this.props.history.push("/login?kiosk=1");
  };

  render() {
    const { online } = this.state;

    const wrap = {
      position: "fixed",
      bottom: 20,
      left: 20,
      // Below MUI's modal/backdrop (1300) so an open dialog dims it like the
      // rest of the page, but above ordinary content.
      zIndex: 1000,
    };
    const chip = {
      display: "flex",
      alignItems: "center",
      gap: 10,
      border: `1px solid ${BORDER}`,
      borderRadius: 6,
      backgroundColor: "#fff",
      // Padding differs per variant in the Figma frame.
      padding: online ? "10px 20px 10px 10px" : "5px 10px",
      fontFamily: "Roboto, sans-serif",
    };
    const dot = {
      width: 7,
      height: 7,
      borderRadius: "50%",
      flexShrink: 0,
      backgroundColor: online ? GREEN : RED,
    };
    const label = {
      fontSize: 12,
      fontWeight: 400,
      color: "#000",
      whiteSpace: "nowrap",
    };

    return (
      <div style={wrap}>
        <div style={chip}>
          <span style={dot} />
          <span style={label}>
            {online ? "Kiosk Online" : "Kiosk Disconnected"}
          </span>
          {!online && (
            <Button
              onClick={this.handleLogin}
              disableElevation
              style={{
                border: `1px solid ${PRIMARY}`,
                borderRadius: 6,
                padding: "4px 8px",
                minWidth: 0,
                fontSize: 12,
                fontWeight: 400,
                lineHeight: "normal",
                textTransform: "none",
                color: "#000",
              }}
            >
              Login
            </Button>
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(KioskStatus);
